<template lang="pug">
div
  svg(class="graph-wrapper" ref="svg" width="100%" height="600")
  v-btn(
    title="Limpiar ruta de tradición"
    @click="cleanTradition"
    elevation="2" small class="clear-button") Limpiar Selección
</template>

<script>
import * as d3 from 'd3';
import dagreD3 from 'dagre-d3';
import dagre from 'dagre';

const fillHighlightColor = '#E1BEE7',
  contourHighlightColor = '#0D47A1';

const colorStatusText = {
  Activo: '#33691E',
  Cerrado: '#757575',
  Desconocido: 'white'
}

export default {
  name: 'FolioGraph',

  props: {
    // propiedad con el listado de los nodos
    nodes: {
      type: Array,
      required: true,
    },
    // propiedad con el listado de conexiones de los nodos
    edges: {
      type: Array,
      required: true,
      // [{ source, target, label }]
    },
    // propiedad que define la orientación del grafo
    orientation: {
      type: String,
      default: 'TB', // TB: top-bottom, LR: left-right
    },
    // propiedad que tiene el nodo raíz
    seed: {
      type: String,
      default: '',
    },
    // porpiedad que indica como buscar el la tradición
    ancestorsMode: {
      type: Boolean,
      default: true
    }
  },

  data() {
    return {
      g: null,
      svgGroup: null,
      selectedNodeId: null
    }
  },
  
  watch: {
    nodes: 'renderGraph',
    edges: 'renderGraph',
    orientation: 'renderGraph',
    seed: 'renderGraph',
  },

  mounted() {
    this.renderGraph();
  },

  methods: {
    // metodo para obtener el color del nodo
    getNodeColor(nodeId, avalaible) {
      let color = '#FFCE30';
      // si el nodo es la semilla
      if (nodeId === this.seed) {
        color = '#E53935'
      }
      // si el nodo no esta disponible
      if (!avalaible) {
        color = '#9E9E9E';
      }
      return color;
    },
    // metodo para encontrar la ruta de relación
    getRelatives(nodeId) {
      const visited = new Set();
      const stack = [nodeId];
      const edges = [];

      while (stack.length > 0) {
        const current = stack.pop();
        if (visited.has(current)) continue;
        visited.add(current);
        let relatives = [];
        if (this.ancestorsMode) {
          relatives = this.g.predecessors(current) || [];
        } else {
          relatives = this.g.successors(current) || [];
        }
        relatives.forEach(target => {
          edges.push({ source: current, target });
          stack.push(target);
        })
      }

      return { nodes: Array.from(visited), edges };
    },
    // limpiar seleccion de tradicion
    cleanTradition() {
      this.nodes.forEach((x) => {
        const safeId = CSS.escape(x.id);
        this.svgGroup.select(`#${safeId} rect`)
          .style('stroke', 'black')
          .style('fill', this.getNodeColor(x.id, x.avalaible))
          .style('stroke-width', 1.5)
      })
      this.svgGroup.selectAll('g.edgePath path')
        .style('stroke', '#555')
        .style('stroke-width', 1.5)
      this.$emit('clear-tradition');
    },
    // metodo para resaltar la ruta
    highlightPath({ nodes, edges }) {
      // Reset estilos de los nodos
      this.nodes.forEach((x) => {
        const safeId = CSS.escape(x.id);
        this.svgGroup.select(`#${safeId} rect`)
          .style('stroke', 'black')
          .style('fill', this.getNodeColor(x.id, x.avalaible))
          .style('stroke-width', 1.5)
      })

      this.svgGroup.selectAll('g.edgePath path')
        .style('stroke', '#555')
        .style('stroke-width', 1.5)

      // Resaltar nodos
      nodes.forEach(id => {
        const safeId = CSS.escape(id);
        this.svgGroup.select(`#${safeId} rect`)
          .style('stroke', contourHighlightColor)
          .style('fill', fillHighlightColor)
          .style('stroke-width', 3)
      })

      // Resaltar edges
      edges.forEach(({ source, target }) => {
        let edgeId = '';
        if (this.ancestorsMode) {
          edgeId = `edge-${target}-${source}`;
        } else {
          edgeId = `edge-${source}-${target}`;
        }
        this.svgGroup.select(`#${edgeId} path`)
          .style('stroke', contourHighlightColor)
          .style('stroke-width', 3)
      })
    },
    renderGraph() {
      const g = new dagre.graphlib.Graph({ multigraph: true })
      g.setGraph({ rankdir: this.orientation, marginx: 20, marginy: 20 })
      g.setDefaultEdgeLabel(() => ({}))

      // Agregar nodos
      this.nodes.forEach((node) => {
        const fillColor = this.getNodeColor(node.id, node.avalaible);
        // Crear nodo personalizado
        const svgLabel = document.createElementNS('http://www.w3.org/2000/svg', 'text');
        // svgLabel.style = "text-anchor: middle"
        // el nombre del folio
        const nodeName = document.createElementNS('http://www.w3.org/2000/svg','tspan');
        nodeName.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        nodeName.setAttribute('dy', '1em');
        nodeName.setAttribute('x', '1');
        nodeName.textContent = node.name;
        svgLabel.appendChild(nodeName);
        // El estado del folio
        const nodeStatus = document.createElementNS('http://www.w3.org/2000/svg','tspan');
        nodeStatus.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        nodeStatus.setAttribute('dy', '1em');
        nodeStatus.setAttribute('x', '1');
        nodeStatus.style = `font-size: 14px;font-weight: 500;fill:${colorStatusText[node.attributes.state]}`
        nodeStatus.textContent = node.attributes.state;
        svgLabel.appendChild(nodeStatus);
        // la fecha de apertura
        const startedDate = document.createElementNS('http://www.w3.org/2000/svg','tspan');
        startedDate.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        startedDate.setAttribute('dy', '1rem');
        startedDate.setAttribute('x', '1');
        startedDate.style = 'font-size: 12px;font-weight: 300;'
        startedDate.textContent = node.attributes.started;
        svgLabel.appendChild(startedDate);
        // si tiene traslados agreagr información
        if (node.attributes.transfers.length > 0) {
          const transferData = document.createElementNS('http://www.w3.org/2000/svg','tspan');
          transferData.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
          transferData.setAttribute('dy', '1.5rem');
          transferData.setAttribute('x', '1');
          transferData.style = 'font-size: 16px;font-weight: 500; fill: purple'
          transferData.textContent = node.attributes.transfers[0];
          svgLabel.appendChild(transferData);
        }
        g.setNode(node.id, {
          id: node.id,
          // label: node.name,
          style: `fill: ${fillColor};
                  stroke: black;
                  stroke-width: 2;
                  cursor: pointer;`,
          shape: 'rect',
          rx: 5,
          ry: 5,
          // padding: 10,
          labelType: 'svg',
          label: svgLabel
        })
      })

      // Agregar edges
      this.edges.forEach((edge) => {
        g.setEdge(edge.source, edge.target, {
          label: edge.label || '',
          id: `edge-${edge.source}-${edge.target}`,
          // lineInterpolate: 'basis',
          arrowheadStyle: 'fill: #333',
          curve: d3.curveBasis,
          style: 'stroke: #555; stroke-width: 1.5; fill: none',
        })
      })

      // Crear render
      const render = new dagreD3.render();

      // Seleccionar SVG y limpiar
      const svg = d3.select(this.$refs.svg);
      svg.selectAll('*').remove();

      // Crear un grupo para el grafo
      const svgGroup = svg.append('g');

      // Renderizar grafo en el grupo
      render(svgGroup, g);

      // Manejar click en el nodo
      svgGroup.selectAll('g.node').on('click', (event, nodeId) => {
        this.selectedNodeId = nodeId;
        const pathNodes = this.getRelatives(nodeId);
        this.highlightPath(pathNodes);
        const nodeData = this.nodes.find(n => n.id === nodeId);
        this.$emit('node-click', { id: nodeId, data: nodeData });
      })

      // Ajustar zoom y posición
      const svgWidth = +svg.attr('width');
      const svgHeight = +svg.attr('height');
      const graphWidth = g.graph().width + 40;
      const graphHeight = g.graph().height + 40;

      const zoom = d3.zoom().on('zoom', (event) => {
        svgGroup.attr('transform', event.transform);
      })
      svg.call(zoom);

      // Centrar el grafo
      const xCenterOffset = (svgWidth - graphWidth) / 2;
      const yCenterOffset = (svgHeight - graphHeight) / 2;
      svgGroup.attr('transform', `translate(${xCenterOffset},${yCenterOffset})`);

      this.g = g;
      this.svgGroup = svgGroup;
    },
  },
}
</script>

<style scoped>
svg.graph-wrapper {
  border: 1px solid #ccc;
  background-color: #fafafa;
  cursor: grab;
}

.clear-button {
  position: absolute;
  top: 50px;
  left: 10px;
}
</style>